import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Category } from 'src/app/core/models/categories.models';
import { Portal } from 'src/app/core/models/portal.models';
import { PortalStoreService } from 'src/app/core/store/services/portal-store.service';

@Component({
  selector: 'craft-category-privacy-icon',
  templateUrl: './craft-category-privacy-icon.component.html',
  styleUrls: ['./craft-category-privacy-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CraftCategoryPrivacyIconComponent implements OnInit {
  @Input() public category: Readonly<Category>;
  public portal: Readonly<Portal>;

  constructor(private portalStore: PortalStoreService) {}

  public ngOnInit() {
    this.portal = this.portalStore.portalSnapshot!;
  }
}
